import React from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from '../styles/staticPages.js';
import Parallax from "components/Parallax/Parallax";
import { useSelector } from "react-redux";
import { colors } from "components/Theme/WebTheme.js";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);


export default function TermCondition(props) {
  const classes = useStyles();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { ...rest } = props;

  return (
    <div style={{ margin: '-8px' }}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{ height: 400, color: 'white' }}
        {...rest}
      />
      <Parallax small filter image={require('assets/img/header-back.jpg')} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <br />

          {/* FR Section */}
          <h2
            style={{
              position: 'relative',
              marginTop: '30px',
              minHeight: '32px',
              color: colors.Header,
              textDecoration: 'none',
              wordBreak: 'break-word',
            }}
          >
            Conditions générales d’utilisation (CGU)
          </h2>

          <p className={classes.ltrDescription}>
            Les présentes conditions encadrent l’utilisation du service Allô Driver. En
            utilisant notre site et/ou notre application mobile, vous acceptez ces
            conditions et notre politique de confidentialité.
          </p>

          <h3 className={classes.sectionTitle}>Collecte et utilisation des données personnelles</h3>
          <p className={classes.ltrDescription}>
            Nous collectons uniquement les informations personnelles strictement
            nécessaires au fonctionnement du service (par exemple : création de compte,
            gestion des trajets, assistance et facturation). Ces informations ne sont
            pas vendues ni partagées à des fins publicitaires.
          </p>

          <h3 className={classes.sectionTitle}>Collecte et utilisation des données de localisation</h3>
          <p className={classes.ltrDescription}>
            Notre application peut collecter et traiter des données de localisation (GPS
            ou localisation approximative) afin de fournir les services proposés, tels que
            la mise en relation avec des conducteurs à proximité et l’optimisation des
            trajets. Ces données de localisation sont uniquement utilisées pour le bon
            fonctionnement de l’application et ne sont pas partagées avec des tiers à des
            fins publicitaires. Vous pouvez désactiver l’accès à la localisation depuis les
            paramètres de votre appareil, mais certaines fonctionnalités pourraient alors
            ne pas être disponibles.
          </p>

          <h4 className={classes.sectionSubTitle}>Pour l’application mobile</h4>
          <p className={classes.ltrDescription}>
            Pour l'application mobile : l'application peut collecter et utiliser des
            données de localisation (GPS ou localisation approximative) afin de fournir
            des fonctionnalités essentielles telles que la mise en relation avec des
            conducteurs à proximité, l'optimisation des trajets et le suivi en temps réel.
            Ces données sont utilisées uniquement pour le bon fonctionnement de
            l'application et ne sont pas partagées avec des tiers à des fins publicitaires.
            Vous pouvez désactiver l'accès à la localisation depuis les paramètres de votre
            appareil ; certaines fonctionnalités peuvent alors ne plus être disponibles.
          </p>

          <h3 className={classes.sectionTitle}>Contact</h3>
          <p className={classes.ltrDescription}>
            Pour toute question relative aux présentes conditions ou à vos données,
            contactez-nous à
            {" "}
            {settings && settings.contact_email ? (
              <a href={`mailto:${settings.contact_email}`}>
                <strong>{settings.contact_email}</strong>
              </a>
            ) : (
              <strong> notre adresse e‑mail de contact</strong>
            )}
            .
          </p>

          <hr style={{ margin: '32px 0' }} />

          {/* EN Section */}
          <h2
            style={{
              position: 'relative',
              marginTop: '10px',
              minHeight: '32px',
              color: colors.Header,
              textDecoration: 'none',
              wordBreak: 'break-word',
            }}
          >
            Terms and Conditions
          </h2>

          <p className={classes.ltrDescription}>
            These terms govern the use of the Allô Driver service. By using our website
            and/or our mobile application, you agree to these terms and to our privacy
            policy.
          </p>

          <h3 className={classes.sectionTitle}>Collection and use of personal data</h3>
          <p className={classes.ltrDescription}>
            We collect only the personal information strictly necessary for core service
            functionality (e.g., account creation, trip management, support, and
            invoicing). This information is not sold or shared for advertising purposes.
          </p>

          <h3 className={classes.sectionTitle}>Collection and use of location data</h3>
          <p className={classes.ltrDescription}>
            Our application may collect and process location data (GPS or approximate
            location) to provide the services offered, such as connecting you with nearby
            drivers and optimizing routes. These location data are used solely for the
            proper functioning of the application and are not shared with third parties
            for advertising purposes. You can disable location access in your device
            settings; however, some features may not be available afterwards.
          </p>

          <h4 className={classes.sectionSubTitle}>For the mobile app</h4>
          <p className={classes.ltrDescription}>
            For the mobile app: the application may collect and use location data (GPS or
            approximate location) to provide essential features such as connecting with
            nearby drivers, route optimization, and real‑time tracking. These data are
            used only to operate the app and are not shared with third parties for
            advertising purposes. You may disable access to location from your device
            settings; some features may then become unavailable.
          </p>

          <h3 className={classes.sectionTitle}>Contact</h3>
          <p className={classes.ltrDescription}>
            For any questions regarding these terms or your data, please contact us at
            {" "}
            {settings && settings.contact_email ? (
              <a href={`mailto:${settings.contact_email}`}>
                <strong>{settings.contact_email}</strong>
              </a>
            ) : (
              <strong>our contact email address</strong>
            )}
            .
          </p>

          <br />
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
}
